// import {
//   Database,
//   Shield,
//   Zap,
//   CheckCircle,
//   Layers,
//   Globe,
//   Cpu,
//   Grid3x3,
//   ArrowRight,
// } from "lucide-react";
// import { useEffect, useRef, useState } from "react";

// const AITrainingDataPage = () => {
//   const refs = useRef([]);
//   const [visible, setVisible] = useState(new Set());

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((e) => {
//           if (e.isIntersecting) {
//             setVisible((prev) => new Set(prev).add(e.target));
//           }
//         });
//       },
//       { threshold: 0.15 }
//     );

//     refs.current.forEach((el) => el && observer.observe(el));
//     return () => observer.disconnect();
//   }, []);

//   const addRef = (el) => el && refs.current.push(el);

//   const services = [
//     {
//       icon: Database,
//       title: "Multimodal Data Collection",
//       desc: "Text, image, video, and audio datasets for AI training.",
//     },
//     {
//       icon: Zap,
//       title: "Data Cleaning & Curation",
//       desc: "Noise removal, normalization, and deduplication.",
//     },
//     {
//       icon: CheckCircle,
//       title: "Annotation & Enrichment",
//       desc: "Human-in-the-loop labeling with metadata enrichment.",
//     },
//     {
//       icon: Shield,
//       title: "Governance & Compliance",
//       desc: "Ethical sourcing with privacy and regulatory alignment.",
//     },
//   ];

//   const datasetTypes = [
//     { title: "OCR Datasets", desc: "Scanned documents & text recognition." },
//     { title: "NLP / NLU", desc: "Intent, entities & conversational data." },
//     { title: "Computer Vision", desc: "Object detection & segmentation." },
//     { title: "Speech & Audio", desc: "Voice recognition & audio analytics." },
//     { title: "Time-Series", desc: "Sequential financial & industrial data." },
//     { title: "Sensor & IoT", desc: "Telemetry & robotics data streams." },
//   ];

//   const capabilities = [
//     {
//       title: "High-Volume Pipelines",
//       desc: "Scalable infrastructure handling millions of records.",
//     },
//     {
//       title: "Custom Taxonomies",
//       desc: "Flexible schemas tailored to business needs.",
//     },
//     {
//       title: "Multi-Format Support",
//       desc: "JSON, CSV, COCO, YOLO & custom formats.",
//     },
//     {
//       title: "API Integration",
//       desc: "Seamless connection with ML workflows.",
//     },
//   ];

//   const industries = [
//     "Autonomous Vehicles",
//     "Healthcare & Diagnostics",
//     "Finance & Insurance",
//     "Retail & E-Commerce",
//     "Robotics & Automation",
//     "Smart Cities & IoT",
//   ];

//   const process = [
//     {
//       title: "Requirement Analysis",
//       desc: "Define dataset scope, quality metrics & timelines.",
//     },
//     {
//       title: "Data Collection",
//       desc: "Secure ingestion and preprocessing.",
//     },
//     {
//       title: "Curation & Annotation",
//       desc: "Expert labeling with strict guidelines.",
//     },
//     {
//       title: "Quality Validation",
//       desc: "Multi-stage review and accuracy checks.",
//     },
//     {
//       title: "Delivery & Support",
//       desc: "Standard exports with continuous iteration.",
//     },
//   ];

//   return (
//     <div className="min-h-screen bg-white font-inter">
//       <style>{`
//         .fade {
//           opacity: 0;
//           transform: translateY(24px);
//           transition: all 0.6s ease;
//         }
//         .fade.show {
//           opacity: 1;
//           transform: translateY(0);
//         }
//       `}</style>

//       {/* HERO */}
//       <section className="relative h-[500px] overflow-hidden bg-slate-900">
//         {/* Background Image */}
//         <div
//           className="absolute inset-0 bg-cover bg-center"
//           style={{
//             backgroundImage:
//               "url('https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=1920&q=80')",
//           }}
//         />

//         {/* Dark overlay (ecommerce style) */}
//         <div className="absolute inset-0 bg-black/75" />

//         <div className="relative max-w-7xl mx-auto px-6 h-full flex items-center">
//           <div className="text-white max-w-3xl">
//             <h1 className="text-4xl sm:text-5xl font-light mb-4 tracking-tight">
//               AI Training Data Services
//             </h1>

//             <p className="text-lg text-slate-300 max-w-2xl mb-6 font-light">
//               Enterprise-grade datasets powering machine learning and AI
//               systems.
//             </p>

//             <button className="inline-flex items-center gap-2 bg-white text-slate-900 px-7 py-3 rounded-md font-medium hover:bg-slate-100 transition-colors">
//               Get Started
//               <ArrowRight className="w-4 h-4" />
//             </button>
//           </div>
//         </div>
//       </section>

//       {/* SERVICES */}
//       <section className="py-24 px-6">
//         <div className="max-w-7xl mx-auto">
//           <h2 className="text-4xl font-light text-center mb-16">
//             AI Data Services
//           </h2>

//           <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
//             {services.map((s, i) => (
//               <div
//                 key={i}
//                 ref={addRef}
//                 className={`p-8 bg-slate-900 text-white fade ${
//                   visible.has(refs.current[i]) ? "show" : ""
//                 }`}
//               >
//                 <s.icon className="w-8 h-8 mb-4" />
//                 <h3 className="text-xl font-medium mb-2">{s.title}</h3>
//                 <p className="text-slate-300 text-sm font-light">{s.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* DATASETS */}
//       <section className="py-24 px-6 bg-slate-50">
//         <div className="max-w-7xl mx-auto">
//           <h2 className="text-4xl font-light text-center mb-16">
//             Dataset Types
//           </h2>

//           <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
//             {datasetTypes.map((d, i) => (
//               <div
//                 key={i}
//                 ref={addRef}
//                 className={`p-6 bg-white border border-slate-200 fade ${
//                   visible.has(refs.current[4 + i]) ? "show" : ""
//                 }`}
//               >
//                 <h3 className="text-lg font-medium mb-2">{d.title}</h3>
//                 <p className="text-slate-600 text-sm font-light">{d.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CAPABILITIES */}
//       <section className="py-24 px-6">
//         <div className="max-w-7xl mx-auto">
//           <h2 className="text-4xl font-light text-center mb-16">
//             Technical Capabilities
//           </h2>

//           <div className="grid md:grid-cols-2 gap-6">
//             {capabilities.map((c, i) => (
//               <div
//                 key={i}
//                 ref={addRef}
//                 className={`p-8 bg-slate-900 text-white fade ${
//                   visible.has(refs.current[10 + i]) ? "show" : ""
//                 }`}
//               >
//                 <Grid3x3 className="w-6 h-6 mb-4" />
//                 <h3 className="text-xl font-medium mb-2">{c.title}</h3>
//                 <p className="text-slate-300 text-sm font-light">{c.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* INDUSTRIES */}
//       <section className="py-24 px-6 bg-slate-50">
//         <div className="max-w-7xl mx-auto">
//           <h2 className="text-4xl font-light text-center mb-16">
//             Industries We Support
//           </h2>

//           <div className="grid md:grid-cols-3 gap-6">
//             {industries.map((ind, i) => (
//               <div
//                 key={i}
//                 ref={addRef}
//                 className={`p-6 bg-white border border-slate-200 fade ${
//                   visible.has(refs.current[14 + i]) ? "show" : ""
//                 }`}
//               >
//                 <Globe className="w-6 h-6 mb-4 text-slate-700" />
//                 <p className="font-light">{ind}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* PROCESS */}
//       <section className="py-24 px-6 bg-slate-900 text-white">
//         <div className="max-w-6xl mx-auto">
//           <h2 className="text-4xl font-light text-center mb-16">
//             AI Data Lifecycle
//           </h2>

//           <div className="space-y-6">
//             {process.map((p, i) => (
//               <div key={i} className="flex gap-6 p-8 bg-slate-800">
//                 <div className="w-12 h-12 bg-white text-slate-900 flex items-center justify-center">
//                   {i + 1}
//                 </div>
//                 <div>
//                   <h3 className="text-xl font-medium mb-1">{p.title}</h3>
//                   <p className="text-slate-300 font-light">{p.desc}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA */}
//       <section className="py-24 bg-white border-t border-slate-200">
//         <div className="max-w-4xl mx-auto text-center px-6">
//           <h2 className="text-3xl sm:text-4xl font-light mb-8">
//             Need Reliable Training Data?
//           </h2>
//           <button className="inline-flex items-center gap-2 bg-slate-900 text-white px-8 py-3 font-medium">
//             Request Training Data <ArrowRight className="w-4 h-4" />
//           </button>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default AITrainingDataPage;


import {
  Database,
  ShieldCheck,
  Zap,
  CheckCircle2,
  Layers,
  Globe2,
  Cpu,
  Grid3x3,
  ArrowRight,
  Fingerprint,
  Activity,
  Workflow,
  SearchCode
} from "lucide-react";
import { motion } from "framer-motion";
 import { Link } from "react-router-dom";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 },
};

const AITrainingDataPage = () => {
  const services = [
    {
      icon: Database,
      title: "Multimodal Collection",
      desc: "Architecting high-fidelity text, image, video, and audio datasets for specialized AI training.",
    },
    {
      icon: Zap,
      title: "Data Orchestration",
      desc: "Advanced noise removal, normalization, and deduplication protocols for pure training signal.",
    },
    {
      icon: SearchCode,
      title: "Semantic Annotation",
      desc: "Expert human-in-the-loop labeling with granular metadata enrichment and intent mapping.",
    },
    {
      icon: ShieldCheck,
      title: "Regulatory Compliance",
      desc: "Ethically sourced data handling with full alignment to global privacy and governance standards.",
    },
  ];

  const datasetTypes = [
    { title: "OCR Architectures", desc: "Complex document digitization & structural text recognition." },
    { title: "NLP / NLU Corpora", desc: "Intent classification, named entity recognition & dialogue sets." },
    { title: "Computer Vision", desc: "Precision object detection, instance segmentation & scene parsing." },
    { title: "Temporal Audio", desc: "High-frequency voice recognition & acoustic analytics datasets." },
    { title: "Financial Series", desc: "Sequential market telemetry & industrial sensor data streams." },
    { title: "Robotics & IoT", desc: "Dynamic telemetry mapping & spatial coordinate datasets." },
  ];

  const industries = [
    { name: "Autonomous Mobility", icon: Activity },
    { name: "Clinical Diagnostics", icon: ShieldCheck },
    { name: "FinTech & Insurance", icon: Database },
    { name: "Precision Retail", icon: Grid3x3 },
    { name: "Industrial Robotics", icon: Cpu },
    { name: "Smart Infrastructure", icon: Globe2 },
  ];

  return (
    <main className="min-h-screen bg-white font-inter selection:bg-indigo-100">
      {/* ================= HERO SECTION ================= */}
      <section className="relative h-[450px] flex items-center overflow-hidden bg-[#0f172a]">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-20 scale-105"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=1920&q=80')",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f172a] via-[#0f172a]/90 to-transparent" />

        {/* Subtle Tech Grid overlay */}
        <div
          className="absolute inset-0 opacity-[0.05] pointer-events-none"
          style={{
            backgroundImage: `radial-gradient(#4f46e5 0.5px, transparent 0.5px)`,
            backgroundSize: "30px 30px",
          }}
        />

        <div className="relative max-w-7xl mx-auto px-6 w-full text-left">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl"
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[10px] font-bold tracking-[0.3em] uppercase mb-6">
              AI Infrastructure
            </div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 tracking-tight leading-tight">
              Enterprise <span className="text-indigo-400">AI Training</span>{" "}
              Data.
            </h1>
            <p className="text-base text-slate-300 text-white mb-8 leading-relaxed font-light">
              We engineer high-fidelity, ethically sourced ground truth datasets
              designed to accelerate model convergence and mission-critical
              performance.
            </p>
            <div className="flex gap-3">
              <Link
                to="/contact"
                className="bg-indigo-600 text-white px-6 py-2.5 rounded-lg text-sm font-bold hover:bg-indigo-700 transition-all shadow-lg flex items-center gap-2"
              >
                Consult Data Lead <ArrowRight size={16} />
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ================= CORE SERVICES ================= */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-left mb-16">
            <span className="text-indigo-600 text-[11px] font-bold tracking-[0.2em] uppercase block mb-3">
              Capabilities
            </span>
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight">
              Structured Data Engineering
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {services.map((s, idx) => (
              <motion.div
                key={idx}
                {...fadeUp}
                className="group p-8 rounded-2xl border border-slate-100 bg-white hover:border-indigo-100 hover:shadow-xl transition-all"
              >
                <div className="w-12 h-12 bg-slate-50 flex items-center justify-center rounded-xl text-slate-900 group-hover:bg-indigo-600 group-hover:text-white transition-all mb-6">
                  <s.icon size={24} />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-3 tracking-tight group-hover:text-indigo-600 transition-colors">
                  {s.title}
                </h3>
                <p className="text-[13px] text-slate-500 leading-relaxed font-light">
                  {s.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= DATASET TYPES (BENTO GRID) ================= */}
      <section className="py-24 bg-slate-50 border-y border-slate-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-left mb-16">
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight">
              Domain-Specific Taxonomy
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {datasetTypes.map((item, idx) => (
              <motion.div
                key={idx}
                {...fadeUp}
                className="bg-white p-8 rounded-2xl border border-slate-200 shadow-sm hover:border-indigo-500/30 transition-all group"
              >
                <h4 className="text-sm font-bold text-slate-900 mb-2 flex items-center gap-2">
                  <div className="w-1.5 h-1.5 rounded-full bg-indigo-600" />{" "}
                  {item.title}
                </h4>
                <p className="text-xs text-slate-500 leading-relaxed font-light">
                  {item.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= DATA SOVEREIGNTY (DARK ACCENT) ================= */}
      <section className="py-16 md:py-24 bg-white relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <motion.div
            {...fadeUp}
            className="bg-[#0f172a] p-6 sm:p-8 md:p-16 rounded-2xl md:rounded-[2.5rem] text-white relative overflow-hidden grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center"
          >
            {/* Glow Effect */}
            <div className="absolute top-0 right-0 w-40 sm:w-64 h-40 sm:h-64 bg-indigo-500/10 blur-[90px] rounded-full" />

            {/* Left Content */}
            <div className="relative z-10">
              <Fingerprint className="text-indigo-400 mb-4 sm:mb-6" size={32} />

              <h3 className="text-2xl sm:text-3xl font-bold mb-3 sm:mb-4 tracking-tight">
                Security & Data Sovereignty
              </h3>

              <p className="text-slate-400 text-sm sm:text-base md:text-lg font-light leading-relaxed mb-6 sm:mb-8">
                SOC2-compliant pipelines and hardened infrastructure ensure
                enterprise data remains secure, private, and fully protected.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                {[
                  "SOC2 Compliant",
                  "PII Anonymization",
                  "Secure Tunnels",
                  "Encrypted Handoff",
                ].map((feat) => (
                  <div
                    key={feat}
                    className="flex items-center gap-3 bg-white/5 p-3 rounded-xl border border-white/10 backdrop-blur-sm"
                  >
                    <CheckCircle2
                      size={16}
                      className="text-indigo-400 shrink-0"
                    />
                    <span className="text-[11px] sm:text-[12px] font-bold uppercase tracking-widest text-slate-200">
                      {feat}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* Right Image */}
            <div className="relative block lg:block h-[200px] sm:h-[260px] lg:h-[300px] w-full">
              <div className="absolute inset-0 bg-indigo-500/20 blur-3xl rounded-full" />
              <img
                src="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&q=80"
                alt="Security Infrastructure"
                className="rounded-xl sm:rounded-2xl shadow-2xl relative z-10 border border-white/10 opacity-80 h-full w-full object-cover"
              />
            </div>
          </motion.div>
        </div>
      </section>

      {/* ================= INDUSTRIES SUPPORTED ================= */}
      <section className="py-24 bg-slate-50 border-y border-slate-100">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-slate-900 tracking-tight mb-16">
            Domain Reach
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {industries.map((ind, i) => (
              <div
                key={i}
                className="px-4 py-6 border border-slate-200 rounded-2xl bg-white hover:border-indigo-600 hover:shadow-md transition-all group"
              >
                <ind.icon
                  className="mx-auto text-indigo-600 mb-3 group-hover:scale-110 transition-transform"
                  size={24}
                />
                <p className="text-[11px] font-bold text-slate-700 tracking-tight leading-tight">
                  {ind.name}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= FINAL CTA ================= */}
      <section className="py-24 bg-[#0f172a] relative overflow-hidden border-t border-white/5 text-center">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-indigo-500/10 rounded-full blur-[120px]" />

        <div className="relative z-10 max-w-4xl mx-auto px-6">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 tracking-tight text-center">
            Scale Your Training Pipeline.
          </h2>
          <p className="text-slate-400 mb-10 text-lg font-light leading-relaxed max-w-2xl mx-auto text-center">
            High-fidelity data is the bedrock of intelligent systems. Partner
            with our engineering team to build your next generation dataset.
          </p>
          <div className="flex justify-center">
           
            <Link
              to="/contact"
              className="bg-indigo-600 text-white px-6 py-2.5 rounded-lg text-sm font-bold hover:bg-indigo-700 transition-all shadow-lg flex items-center gap-2"
            >
              Initiate Technical Consultation <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default AITrainingDataPage;